import React from 'react'

import { Helmet } from "react-helmet-async";
// icons
import contactus from '../images/contactus.png'

// Components
import HeaderRegComponent from '../Components/HeaderRegComponent'
import FooterComponent from '../Components/FooterComponent'

const ContactUs = () => {
	return (
		<>
      <Helmet>
        <title>Contact Us | OneMap Team</title>
        <meta
          name="description"
          content="Have questions or feedback for the OneMap development team? We’re here to help! As the geospatial agency of Singapore, we value your suggestions to enhance our services. Reach out to us at onemap@sla.gov.sg, and we'll respond promptly!"
        />
      </Helmet>
      <div className="om-body container-fluid">

        <HeaderRegComponent />

        <div className="om-body-content pageBase">
          <div id="om-section-contactus" className='om-sections row'>
            <div className='col-md-6 mb-5'>
              <h2 className="om-orange">If you have any questions, please reach out to us.</h2>
              <p>
                We are the OneMap development team from Singapore Land Authority, the geospatial agency of Singapore. We are constantly seeking ways to improve on our services, your suggestions will be greatly appreciated.
              </p>
              <p>
                Feel free send us feedback at <a className="om-email" href="mailto:onemap@sla.gov.sg">onemap@sla.gov.sg</a> and we will get back to you as soon as possible!
              </p>
            </div>
            <div className='om-contactus-img-frame col-sm-0 col-md-6'>
              <img src={contactus} alt='Contact Us' />
            </div>
          </div>
        </div>

        <FooterComponent />
        
      </div>
		</>
	)
}

export default ContactUs